import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_BLOCKED_SIGNATURE_EXPORT = createFcmDetails('blocked_signature_export', {
	owner: 'Site Platform',
	context: 'export-svc',
	description: 'Used to configure which countries have signature exports disabled.',
	import: false,
});
